/** @format */

export default async function Logout(navigate, dispatch) {
  await navigate("/login", { replace: true });
  await dispatch;
  await localStorage.clear();
}
